module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_features_02-5800cc922eb2ebfb3590590cae8fc1ea.png";